import { getGameConfig } from '../../../config/gameConfig';
import type { Settlement, ToolItem } from '../types';

export function createToolItem(settlement: Settlement): ToolItem {
    const config = getGameConfig();
    settlement.toolIdCounter += 1;
    return {
        id: `tool_${settlement.id}_${settlement.toolIdCounter}`,
        durability: config.tool.initialDurability,
    };
}
